<div class="form-row" [formGroup]="formGroup">
  <!-- Datum -->
  <app-form-group formControlName="date" id="dateReservationDate" name="reservationDate" [class.col-4]="!hideButtons"
    [class.col-6]="hideButtons" class="col-lg-3 mb-1" type="date" [placeholder]="dateFormat" placement="bottom-left"
    [hideLabels]="hideLabels" text="{{'DATE'|translate}}" required="true"></app-form-group>

  <!-- Zeit von -->
  <app-form-group formControlName="dateTimeFrom" id="dropdownDateTimeFrom" name="dateTimeFrom"
    class="col-3 col-lg-3 mb-1" type="time-combobox" [selectData]="selectTimeFromValues" [hideLabels]="hideLabels"
    text="{{'TIMESPAN_START'|translate}}" required="true" [firstAsDefault]="true" [targetDate]="formDate">
  </app-form-group>

  <!-- Zeit bis -->
  <app-form-group formControlName="dateTimeTo" id="dropdownDateTimeTo" name="dateTimeTo" class="col-3 col-lg-3 mb-1"
    type="time-combobox" [selectData]="selectTimeToValues" [hideLabels]="hideLabels" text="{{'TIMESPAN_END'|translate}}"
    required="true" [firstAsDefault]="true" [targetDate]="formDate"></app-form-group>


  <div *ngIf="!hideButtons" class="col-2 col-lg-3 mb-1">
    <label style="display: block;" *ngIf="!hideLabels">&nbsp;</label>
    <!-- state tooltips -->
    <app-tooltip-button *ngIf="displayIndicatorOk" btnClass="text-success" text="{{'ALL_OK'|translate}}" icon="check">
    </app-tooltip-button>
    <app-tooltip-button *ngIf="displayIndicatorError" btnClass="text-danger" text="{{'ERR'|translate}}" icon="warning">
    </app-tooltip-button>

    <!-- action buttons -->
    <!-- save -->
    <app-button *ngIf="displaySaveButton" btnClass="ml-1" text="{{'BTN_SAVE'|translate}}" [working]="isWorking"
      [hideText]="true" icon="file" [disabled]="!enableSaveButton" (buttonClick)="onSaveClick()"></app-button>
    <!-- delete -->
    <app-button *ngIf="displayDeleteButton" btnClass="ml-1" text="{{'BTN_DELETE'|translate}}" btnStyle="danger"
      [working]="isWorking" [hideText]="true" icon="trash" [disabled]="!enableDeleteButton"
      (buttonClick)="onDeleteClick()">
    </app-button>
    <!-- cancel -->
    <app-button *ngIf="displayCancelButton" btnClass="ml-1" text="{{'BTN_CANCEL'|translate}}"
      btnStyle="outline-secondary" [working]="isWorking" [hideText]="true" icon="x" (buttonClick)="onCancelClick()">
    </app-button>
  </div>

  <!-- state info -->
  <ng-container *ngIf="conflictReport && !supressErrorMessageNotice">

    <span class="w-100 pl-2 mb-2 d-block line-h-100">
      <span class="small mr-1">{{'CONFLICTS'|translate}}:</span>

      <span class="invalid-feedback d-inline-block conflict-time m-0" *ngFor="let ts of conflictReport.occupancies">
        {{'TIMESPAN_UNTIL'| translate : {
        startTime: getCHTimeString(ts.DateTimeFrom),
        endTime: getCHTimeString(ts.DateTimeTo)
        } }}
      </span>
    </span>

  </ng-container>

</div>